function FindTheStatus(status) {
    if (status === 0) return "Idle";
  else if (status === 2) return "Discharging";
  else if (status === 4) return "Charging";
  else return "Undetermined";
  }
export default FindTheStatus